const formName = document.querySelector(`[data-type="add-to-cart-form"]`)?.getAttribute("id");
const earmoldColorWrapperDiv = document.querySelector("#earmold-color-wrapper");
const expandColorsButton = document.querySelector("#expand-earmold-color-wrapper");

const buildHexColor = (colorName, index) => {
    return `
    <div class="color-block-wrapper">
        <div class="color-input-wrapper">
            <svg class="checkmark" aria-hidden="true"><use href="#checkmark-icon"></svg>
            <input form="${formName}" required aria-invalid="false"
            class="color-input" name="properties[Earplug Color]" type="radio" value="${colorName}"
            id="color-${index}" />
        </div>
        <label for="color-${index}">${colorName}</label>
    </div>
    `;
};

const buildImageColor = (colorFromMap, colorName, index) => {
    return `
        <div class="color-block-wrapper">
            <div class="color-input-wrapper">
                <img src="${colorFromMap}" alt="" width="60" height="60" loading="lazy" class="swatch-image" />
                <svg class="checkmark" aria-hidden="true"><use href="#checkmark-icon"></svg>
                <input form="${formName}" required aria-invalid="false"
                class="color-input" name="properties[Earplug Color]" type="radio" value="${colorName}"
                id="color-${index}" />
            </div>
            <label for="color-${index}">${colorName}</label>
        </div>
    `;
};

// Build color inputs from productColors array on product page.
if (earmoldColorWrapperDiv) {
    for (const [index, colorName] of productColors.entries()) {
        const colorFromMap = earplugColors.get(colorName);
        
        if (!colorFromMap) {
            console.error(`Color "${colorName}" from Shopify Admin could not be found in earplugColors Map.`);
            continue;
        }

        const colorIsImage = !!colorFromMap.match(/\.(?:jpg|png|webp)$/i);

        const colorBlockInnerHTML = (() => {
            if (colorIsImage) {
                return buildImageColor(colorFromMap, colorName, index);
            } else {
                return buildHexColor(colorName, index);
            }
        })();
        
        const colorBlockElement = document.createElement("div");
        
        // Input gets background color here for hex values.
        if (!colorIsImage) colorBlockElement.setAttribute("style", `--swatch: #${colorFromMap};`);
        
        colorBlockElement.classList.add("color-block");
        colorBlockElement.innerHTML = colorBlockInnerHTML;

        earmoldColorWrapperDiv.appendChild(colorBlockElement);
    }

    if (productColors.length < 5) {
        earmoldColorWrapperDiv.classList.add("expanded");
        expandColorsButton.remove();
    }
}

const disable = (inputId) => {
    const element = document.querySelector(`#${inputId}`);
    const tag = element.tagName.toLowerCase();

    const containerBlock = element.closest(".input-wrapper");

    if (containerBlock) {
        containerBlock.classList.add("display-none");
    }

    switch (tag) {
        case "input": {
            element.setAttribute("disabled", "");
            element.removeAttribute("required");
            element.checked = false;
            element.value = "";
            
            break;
        }

        case "fieldset":
        case "div": {
            const inputs = element.querySelectorAll("input");

            inputs.forEach(input => {
                disable(input);
            });

            element.classList.add("display-none");
            
            break;
        }

        case ("select"): {
            element.classList.add("display-none");
            element.selectedIndex = 0;
            element.setAttribute("disabled", "");
            
            break;
        }

        default: { break; }
    }
};

const enable = (inputId) => {
    const element = document.querySelector(`#${inputId}`);
    const tag = element.tagName.toLowerCase();

    const containerBlock = element.closest(".input-wrapper");
    if (containerBlock) {
        containerBlock.classList.remove("display-none");
    }

    switch (tag) {
        case "input": {
            element.removeAttribute("disabled");
            element.checked = false;

            if (element.hasAttribute("data-is-required")) {
                element.setAttribute("required", "");
            }

            break;
        }

        case "fieldset":
        case "div": {
            const inputs = element.querySelectorAll("input");

            inputs.forEach(input => {
                enable(input);
            });

            element.classList.remove("display-none");
        }

        case ("select"): {
            element.classList.remove("display-none");
            element.removeAttribute("disabled");
        }

        default: { break; }
    }
};

const checkProductConfig = (inputId) => {
    if (!productConfig.has(inputId)) return;

    // Run side effects, if any.
    if (productConfig.get(inputId).toRun) {
        productConfig.get(inputId).toRun();
    }

    // Disable elements by ID.
    if (productConfig.get(inputId).disable) {
        productConfig.get(inputId).disable.forEach(elementId => {
            disable(elementId);
        });
    }

    // Enable elements by ID.
    if (productConfig.get(inputId).enable) {
        productConfig.get(inputId).enable.forEach(elementId => {
            enable(elementId);
        });
    }
}

const handleSelectInput = (selectElement) => {
    const selectedIndex = selectElement.selectedIndex;
    const selectedOption = selectElement.options[selectedIndex];
    const selectedId = selectedOption.getAttribute("id");

    checkProductConfig(selectedId);
}

const handleInput = (event) => {
    if (!productConfig) return;

    const target = event.target;

    const inputType = (() => {
        const tag = target.tagName.toLowerCase();

        if (tag === "select") {
            return tag;
        }

        if (tag === "input") {
            return target.getAttribute("type") || "text";
        }

        return null;
    })();

    switch (inputType) {
        case "select": {
            handleSelectInput(target);
            break;
        }

        default: {
            checkProductConfig(target.getAttribute("id"));
            break;
        }
    }
};

// Add form name to #product-options inputs that are not color inputs,
// because colors inputs are already set when they build.
document.querySelectorAll(`#product-options :is(input, select)`).forEach(input => {
    input.addEventListener("input", handleInput);

    const isColorSwatch = !!input.closest(".color-block");
    if (!isColorSwatch) {
        input.setAttribute("form", formName);
    }
});

const handleExpandColorsButton = (event) => {
    if (!earmoldColorWrapperDiv) return;

    const colorIsExpanded = earmoldColorWrapperDiv.classList.contains("expanded");

    if (colorIsExpanded) {
        earmoldColorWrapperDiv.classList.remove("expanded");
        expandColorsButton.setAttribute("expanded", "false");
        expandColorsButton.textContent = "Expand color window"
    } else {
        earmoldColorWrapperDiv.classList.add("expanded");
        expandColorsButton.setAttribute("expanded", "true");
        expandColorsButton.textContent = "Collapse color window"
    }
}

if (expandColorsButton) {
    expandColorsButton.addEventListener("click", handleExpandColorsButton);
}